// app/error.jsx
"use client";

export default function Error({ reset }) {
  return (
    <div>
      <h1>Something went wrong!</h1>
      <p>We've logged this error and will look into it.</p>
      <button onClick={() => reset()}>Try again</button>
    </div>
  );
}
